import React from 'react';
import Sticky from 'react-sticky-el';
import moment from 'moment-timezone';
import { withTranslation } from 'react-i18next';

import Event from './Event';
import PageNav from '../../_ui/PageNav';
import styles from './EventsList.scss';
import Loader from '../../Loader';

// const propTypes = {
//   handleChangePage: React.PropTypes.func.isRequired,
//   isPagination: React.PropTypes.bool.isRequired,
//   page: React.PropTypes.number.isRequired,
//   perPageItems: React.PropTypes.number.isRequired,
//   count: React.PropTypes.number.isRequired,
//   begin: React.PropTypes.number.isRequired,
//   N: React.PropTypes.number.isRequired,
//   events: React.PropTypes.array.isRequired,
//   loading: React.PropTypes.bool.isRequired,
//   timezone: React.PropTypes.string.isRequired,
//   handleAppear: React.PropTypes.func.isRequired,
//   setStickyB: React.PropTypes.func.isRequired,
// };

class EventsList extends React.Component {
  state = {
    windowHeight: window.innerHeight,
  }

  componentDidMount() {
    // размеры видимой области окна для прикрепления постраничной навигации к низу
    window.addEventListener('resize', this.handleWindowResize, true);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize, true);
  }

  handleWindowResize = () => {
    const { windowHeight } = this.state;
    const newHeight = window.innerHeight;
    if (windowHeight !== newHeight) {
      this.setState({ windowHeight: newHeight });
    }
  }

  render() {
    const {
      handleChangePage,
      isPagination,
      page,
      perPageItems,
      count,
      begin,
      N,
      events,
      loading,
      timezone,
      handleAppear,
      t,
    } = this.props;

    if (loading) return <Loader />;
    if (!events[0]) return <div className={styles.nothing}>{t('nothing')}</div>;

    let mDate = moment(events[0].created);
    const items = [<Date date={mDate.format('D MMMM YYYY')} key={events[0].created} />];
    events.forEach(({
      id,
      created,
      service,
      text,
      read,
      bill_pdf_url: billPdfUrl,
      icon_url: iconUrl,
      more_url: moreUrl,
    }) => {
      const date = moment(created).tz(timezone);
      if (!date.isSame(mDate, 'day')) {
        mDate = date.clone();
        items.push(
          <Date date={date.format('D MMMM YYYY')} key={created} />
        );
      }
      items.push(
        <Event
          key={id}
          id={id}
          string={service}
          text={text}
          time={date.format('H:mm')}
          isViewed={read}
          handleAppear={handleAppear}
          billPdfUrl={billPdfUrl}
          iconUrl={iconUrl}
          moreUrl={moreUrl}
        />
      );
    });

    return (
      <div>
        <div className={styles.content}>
          {items}
        </div>

        {isPagination
          && <Sticky
            mode="bottom"
            stickyStyle={{ bottom: '0', top: 'inherit' }}
            stickyClassName={styles.shadowTop}
          >
            <div className={styles.footer}>
              <PageNav
                text={t('paging', { begin, end: (begin + N) - 1, total: count })}
                page={page}
                total={count}
                perPage={perPageItems}
                handleChangePage={handleChangePage}
              />
            </div>
          </Sticky>}
      </div>
    );
  }
}

export default withTranslation('events')(EventsList);

const Date = ({ date }: { date: string }) => (
  <div className={styles.date}>{date}</div>
);
